import React from 'react'
import { Button, Col, Container, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'

import CloseIcon from '../../images/icons/close_panel.svg'

import './newEstimateModal.css'
import { Estimate } from '../../../../back-end/common/estimate'
import { Formik } from 'formik'
import { FormText } from '../ui/Form/Text'
import * as yup from 'yup'
import { Trash2 } from 'react-feather'

export type UpdateableEstimate = Omit<
	Estimate,
	'createTs' | 'modifiedTs' | 'createUserID' | 'modifiedUserID' | 'recordStatusID' | 'current' | 'aged' | 'remaining' | 'hasBeenApproved' | 'isFullyInvoiced'
>

interface NewEstimateModalProps {
	onClose: () => void
	estimate: UpdateableEstimate | null
	handleNewEstimate: (estimate: UpdateableEstimate) => void
	handleEstimateDelete: (estimateId: string) => void
}

const schema = yup.object().shape({
	description: yup.string().required('Description is required').min(3, 'Description minimum length is 3'),
	value: yup.number().required('Value is required').min(0, 'Minimum value is 0'),
	date: yup.date().required('Date is required'),
})

const NewEstimateModal = (props: NewEstimateModalProps) => {
	if (props.estimate === null) {
		return null
	}

	return (
		<div className={'estimate-modal'}>
			<Container>
				<Row className="pb-3">
					<Col onClick={() => props.onClose()} className="panel-close-btn" sm="auto">
						<img src={CloseIcon} alt="Close" className="pr-2" />
						<span className="span-bold span-navy span-body-2">Close</span>
					</Col>
				</Row>

				<Formik
					initialValues={props.estimate}
					validationSchema={schema}
					onSubmit={props.handleNewEstimate}
					validateOnMount={false}
					validateOnChange={false}
				>
					{({ values, errors, handleSubmit, isSubmitting, handleChange }) => {
						return (
							<Form onSubmit={handleSubmit}>
								<Row className="pb-3">
									<Col>
										<FormText
											name="description"
											label="Description"
											value={values.description}
											onChange={handleChange}
											feedback={errors.description}
										/>
									</Col>
								</Row>
								<Row className="pb-3">
									<Col>
										<FormText name="date" type="date" label="Date" value={values.date} onChange={handleChange} feedback={errors.date} />
									</Col>
								</Row>
								<Row className="pb-3">
									<Col>
										<FormText name="value" label="Value" value={values.value} onChange={handleChange} feedback={errors.value} />
									</Col>
								</Row>
								<Row>
									<Col>
										<Button type="submit" disabled={isSubmitting}>
											{values.estimateID ? 'Update' : 'Create'}
										</Button>
										{values.estimateID && (
											<OverlayTrigger
												placement="bottom"
												overlay={(props) => (
													<Tooltip id="delete-tooltip" {...props}>
														Delete
													</Tooltip>
												)}
											>
												<Trash2
													style={{ color: 'red', marginLeft: '17px', alignSelf: 'end', cursor: 'pointer' }}
													size={30}
													onClick={() => props.handleEstimateDelete(values.estimateID)}
												>
													Delete
												</Trash2>
											</OverlayTrigger>
										)}
									</Col>
								</Row>
							</Form>
						)
					}}
				</Formik>
			</Container>
		</div>
	)
}

export default NewEstimateModal
